/**
 * Announcer component for screen reader announcements
 * Manages a live region for accessible announcements
 */
export default class Announcer {
    constructor(container) {
        this.element = null;
        this.container = container;
        this.createAnnouncerElement();
    }
    /**
     * Creates the hidden announcer element with ARIA live region attributes
     */
    createAnnouncerElement() {
        // Check if announcer already exists
        if (this.element && this.element.parentElement) {
            return;
        }
        this.element = document.createElement('div');
        this.element.setAttribute('aria-live', 'polite');
        this.element.setAttribute('aria-atomic', 'true');
        this.element.setAttribute('role', 'status');
        this.element.style.position = 'absolute';
        this.element.style.left = '-10000px';
        this.element.style.width = '1px';
        this.element.style.height = '1px';
        this.element.style.overflow = 'hidden';
        this.element.style.clipPath = 'inset(50%)';
        this.container.appendChild(this.element);
        // Force browser to recognize the live region
        this.element.textContent = '';
    }
    /**
     * Announces a message through the live region
     */
    announce(message) {
        if (!this.element) {
            this.createAnnouncerElement();
        }
        if (this.element) {
            this.element.textContent = message;
        }
    }
    /**
     * Ensures the announcer element is ready
     */
    ensureReady() {
        if (!this.element || !this.element.parentElement) {
            this.createAnnouncerElement();
        }
    }
    /**
     * Destroys the announcer and removes it from the DOM
     */
    destroy() {
        if (this.element && this.element.parentElement) {
            this.element.remove();
        }
        this.element = null;
    }
    /**
     * Gets the announcer element
     */
    getElement() {
        return this.element;
    }
}
